import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  createOffer,
  deleteOffer,
  getOfferById,
  getOfferList,
  updateOffer,
} from '../../services/OfferService'

interface GetOfferListParams {
  pageNumber: number
  pageSize: number
  filterkey: any
}

interface OfferState {
  OfferList: any
  offer: any
}

const initialState: OfferState = {
  OfferList: null,
  offer: null,
}

// Fetch Offer list
export const getOfferListApi = createAsyncThunk(
  'offer/getOfferList',
  async ({pageNumber, pageSize, filterkey}: GetOfferListParams, {rejectWithValue}) => {
    try {
      const result = await getOfferList(pageNumber, pageSize, filterkey)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Fetch Offer by ID
export const getOfferByIdApi = createAsyncThunk(
  'offer/getOfferById',
  async (id: any, {rejectWithValue}) => {
    try {
      const result = await getOfferById(id)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Create a new Offer
export const createOfferApi = createAsyncThunk(
  'offer/createOffer',
  async (payload: any, {rejectWithValue}) => {
    try {
      const result = await createOffer(payload)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Update Offer
export const updateOfferApi = createAsyncThunk(
  'offer/updateOffer',
  async ({id, payload}: {id: any; payload: any}, {rejectWithValue}) => {
    try {
      const result = await updateOffer(id, payload)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Delete Offer
export const deleteOfferApi = createAsyncThunk(
  'offer/deleteOffer',
  async (id: any, {rejectWithValue}) => {
    try {
      const result = await deleteOffer(id)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

const OfferSlice = createSlice({
  name: 'offer',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getOfferListApi.fulfilled, (state, action) => {
        state.OfferList = action.payload
      })
      .addCase(getOfferByIdApi.fulfilled, (state, action) => {
        state.offer = action.payload
      })
      .addCase(createOfferApi.fulfilled, (state, action) => {
        state.offer = action.payload
      })
      .addCase(updateOfferApi.fulfilled, (state, action) => {
        state.offer = action.payload
      })
      .addCase(deleteOfferApi.fulfilled, (state, action) => {
        state.offer = null // Assuming after deletion you want to clear the Offer state
        // Alternatively, you could modify the OfferList if necessary.
      })
  },
})

export default OfferSlice
